import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getLabel } from "../../../../../../../hooks/use-labels";
import ContactSupport from "../ContactSupport";
import HexModal from "../../../../../../../components/HexModal";
import { setCartInformation } from "../../../../../../../redux/reducers/order/order-action";
import { useReorderMutation } from "../../../../../../../features/orders/ordersApi";
import { showInfoToast, showSuccessToast } from "../../../../../../../components/Toast";

const skippedMessage = (skippedProducts) => {
  const [first, ...rest] = skippedProducts;
  const name = first?.product?.name || first?.name || "An item";
  const reason =
    first?.reason === "CONTAINER_OPTION_UNAVAILABLE"
      ? "the chosen cylinder option is no longer offered"
      : "no longer available";

  const more = rest.length ? ` and ${rest.length} more` : "";

  return `${name} was not added — ${reason}.${more}`;
};

const ReorderAndSupport = ({ orderId }) => {
  const [confirmation, showConfirmation] = useState(false);
  const [notification, setNotification] = useState("");

  const [reorder, { isLoading }] = useReorderMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleModal = () => {
    notification && setNotification("");
    showConfirmation((prev) => !prev);
  };

  const onConfirmReorder = async () => {
    try {
      const { carts, skippedProducts } = await reorder({ orderId }).unwrap();

      if (carts?.length) dispatch(setCartInformation(carts[0]));

      if (skippedProducts?.length) {
        showInfoToast(skippedMessage(skippedProducts));
      } else {
        showSuccessToast("Your items are back in the cart.");
      }

      navigate("/my-cart");
    } catch (error) {
      setNotification(error?.message || "Your order could not be reordered.");
    }
  };

  return (
    <Fragment>
      {confirmation && (
        <HexModal open={true} onClose={toggleModal} modalClass="ord-modal">
          <div className="ord-modal-body">
            <span className="ord-modal-icon ord-modal-icon-brand" aria-hidden="true">
              <img src="/assets/icons/warning-icon.svg" alt="" />
            </span>

            <h2 className="ord-modal-title">{getLabel("reorderLabel")}?</h2>

            <p className="ord-modal-text">{getLabel("reorderConfirmation")}</p>

            {notification && <p className="ord-modal-error">{notification}</p>}

            <div className="ord-modal-actions">
              <button
                type="button"
                className="ord-btn ord-btn-outline"
                disabled={isLoading}
                onClick={toggleModal}
              >
                {getLabel("noLabel")}
              </button>

              <button
                type="button"
                className="ord-btn ord-btn-primary"
                disabled={isLoading}
                onClick={onConfirmReorder}
              >
                {isLoading ? "Reordering…" : getLabel("yesLabel")}
              </button>
            </div>
          </div>
        </HexModal>
      )}

      <ContactSupport outline={true} />

      <button
        type="button"
        className="ord-btn ord-btn-primary"
        onClick={toggleModal}
      >
        {getLabel("reorderLabel")}
      </button>
    </Fragment>
  );
};

export default ReorderAndSupport;
